import React from 'react';
import {
    FaHeart,
    FaShippingFast,
    FaPlane,
    FaWarehouse,
    FaRegStar,
    FaStar,
    FaStarHalfAlt,
    FaAward
} from "react-icons/fa";

export const Heart = () => <FaHeart />;
export const LocalShipping = () => <FaShippingFast />
export const International = () => <FaPlane />
export const Warehouse = () => <FaWarehouse />
export const EmptyStar = () => <FaRegStar />
export const HalfStar = () => <FaStarHalfAlt />
export const FullStar = () => <FaStar />
export const DukaApproved = () => <FaAward />